// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContactPage.css */
body {
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;

    color: #333;
}



h1 {
    font-size: 2em;
    margin-bottom: 0.5em;
    color: #4B79A1;
    animation: fadeIn 2s ease-in;
}

p {
    font-size: 1em;
    margin-bottom: 1em;
    color: #283E51;
    animation: fadeIn 1s ease-in;
}

.form-group {
    margin-bottom: 1em;
    width: 100%;
    max-width: 500px;
    text-align: left;
}

.form-group label {
    display: block;
    margin-bottom: 0.5em;
    color: #283E51;
    font-weight: 600;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 0.75em;
    border-radius: 5px;
    border: 1px solid #ddd;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: 1em;
}

.form-group textarea {
    resize: vertical;
}

.button {
    font-size: 1em;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: background 0.3s ease;
    animation: bounceIn 2s ease-in;
}

.button:hover {
    background: #283E51;
}

.weather-info,
.location-info {
    margin: 1em 0;
    font-size: 1em;
    color: #333;
    background: #fff;
    padding: 0.75em;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    text-align: left;
    width: 100%;
    max-width: 500px;
}

.footer {
    padding: 1em;
    text-align: center;
    color: #888;
    background: rgba(255, 255, 255, 0.8);
    border-top: 1px solid #ddd;
    width: 100%;
    position: fixed;
    bottom: 0;
}

.progress-container {
    width: 100%;
    max-width: 500px;
    background: #f3f3f3;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    margin-top: 1em;
}

.progress-bar {
    height: 10px;
    background: #4B79A1;
    border-radius: 5px;
    transition: width 0.3s ease;
}

.progress-text {
    text-align: center;
    color: #4B79A1;
    font-weight: 600;
    padding: 0.5em;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes bounceIn {
    0% {
        transform: scale(0.5);
        opacity: 0;
    }
    60% {
        transform: scale(1.2);
        opacity: 1;
    }
    80% {
        transform: scale(0.9);
    }
    100% {
        transform: scale(1);
    }
}

@media (max-width: 600px) {
    h1 {
        font-size: 1.8em;
    }

    p {
        font-size: 0.9em;
    }

    .form-group label,
    .form-group input,
    .form-group textarea {
        font-size: 0.9em;
    }

    .weather-info,
    .location-info {
        font-size: 0.9em;
    }

    .button {
        font-size: 0.9em;
        padding: 1.6em 1.6em;
    }
}`, "",{"version":3,"sources":["webpack://./src/component/contactPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,SAAS;IACT,UAAU;IACV,kCAAkC;;IAElC,WAAW;AACf;;;;AAIA;IACI,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;AACJ","sourcesContent":["/* ContactPage.css */\r\nbody {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: 'Poppins', sans-serif;\r\n\r\n    color: #333;\r\n}\r\n\r\n\r\n\r\nh1 {\r\n    font-size: 2em;\r\n    margin-bottom: 0.5em;\r\n    color: #4B79A1;\r\n    animation: fadeIn 2s ease-in;\r\n}\r\n\r\np {\r\n    font-size: 1em;\r\n    margin-bottom: 1em;\r\n    color: #283E51;\r\n    animation: fadeIn 1s ease-in;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 1em;\r\n    width: 100%;\r\n    max-width: 500px;\r\n    text-align: left;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 0.5em;\r\n    color: #283E51;\r\n    font-weight: 600;\r\n}\r\n\r\n.form-group input,\r\n.form-group textarea {\r\n    width: 100%;\r\n    padding: 0.75em;\r\n    border-radius: 5px;\r\n    border: 1px solid #ddd;\r\n    font-size: 1em;\r\n    box-sizing: border-box;\r\n    margin-bottom: 1em;\r\n}\r\n\r\n.form-group textarea {\r\n    resize: vertical;\r\n}\r\n\r\n.button {\r\n    font-size: 1em;\r\n    border: none;\r\n    border-radius: 25px;\r\n    cursor: pointer;\r\n    transition: background 0.3s ease;\r\n    animation: bounceIn 2s ease-in;\r\n}\r\n\r\n.button:hover {\r\n    background: #283E51;\r\n}\r\n\r\n.weather-info,\r\n.location-info {\r\n    margin: 1em 0;\r\n    font-size: 1em;\r\n    color: #333;\r\n    background: #fff;\r\n    padding: 0.75em;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    text-align: left;\r\n    width: 100%;\r\n    max-width: 500px;\r\n}\r\n\r\n.footer {\r\n    padding: 1em;\r\n    text-align: center;\r\n    color: #888;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    border-top: 1px solid #ddd;\r\n    width: 100%;\r\n    position: fixed;\r\n    bottom: 0;\r\n}\r\n\r\n.progress-container {\r\n    width: 100%;\r\n    max-width: 500px;\r\n    background: #f3f3f3;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    margin-top: 1em;\r\n}\r\n\r\n.progress-bar {\r\n    height: 10px;\r\n    background: #4B79A1;\r\n    border-radius: 5px;\r\n    transition: width 0.3s ease;\r\n}\r\n\r\n.progress-text {\r\n    text-align: center;\r\n    color: #4B79A1;\r\n    font-weight: 600;\r\n    padding: 0.5em;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-20px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@keyframes bounceIn {\r\n    0% {\r\n        transform: scale(0.5);\r\n        opacity: 0;\r\n    }\r\n    60% {\r\n        transform: scale(1.2);\r\n        opacity: 1;\r\n    }\r\n    80% {\r\n        transform: scale(0.9);\r\n    }\r\n    100% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    h1 {\r\n        font-size: 1.8em;\r\n    }\r\n\r\n    p {\r\n        font-size: 0.9em;\r\n    }\r\n\r\n    .form-group label,\r\n    .form-group input,\r\n    .form-group textarea {\r\n        font-size: 0.9em;\r\n    }\r\n\r\n    .weather-info,\r\n    .location-info {\r\n        font-size: 0.9em;\r\n    }\r\n\r\n    .button {\r\n        font-size: 0.9em;\r\n        padding: 1.6em 1.6em;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
